import { useState, useEffect, useRef } from "react";
import { Box, Typography, IconButton, useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import CustomText, { textStyles } from "../../components/CustomText";
import CustomButton from "../../components/CustomButton";
import InfoCard from "../../components/cards/InfoCard";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import faqsimage from "../../assets/faqsimage.png";
import faqsrightimage from "../../assets/faqsrightimage.png";
import faqsleftimage from "../../assets/faqsleftimage.png";
import whitechat from "../../assets/whitechat.png";
import { BASE_URL } from "../../components/BASE_URL";
import { useTranslation } from "react-i18next";
// Skeleton loader
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const FAQsSection = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("lg"));
  const isSm = useMediaQuery(theme.breakpoints.down("sm"));
  const isMd = useMediaQuery(theme.breakpoints.down("md"));
  const isLg = useMediaQuery(theme.breakpoints.down("lg"));
  const isMobileS = useMediaQuery("(max-width: 320px)");
  const { t ,i18n} = useTranslation();

  const [openIndex, setOpenIndex] = useState(0);

  // 🔹 API State
  const [faqData, setFaqData] = useState({
    title: "",
    description: "",
    list: [],
  });
  const [loading, setLoading] = useState(true);
useEffect(() => {
  async function loadFaqs() {
    setLoading(true);
    try {
      const res = await fetch(
        `${BASE_URL}content/sections?page=1&limit=10&sort=order&include=items&search=FAQs`
      );
      const json = await res.json();

      const section = (json?.data || []).find(
        (s) => s?.name?.trim().toLowerCase() === "faqs"
      );

      if (section?.items?.length) {
        const selectedItem =
          i18n.language === "es"
            ? section.items.find((item) => item.idx === 1)
            : section.items.find((item) => item.idx === 0);

        const parsedList = Array.isArray(selectedItem?.list)
          ? selectedItem.list
          : selectedItem?.list
            ? JSON.parse(selectedItem.list)
            : [];

        setFaqData({
          title: selectedItem?.title || "",
          description: selectedItem?.description || "",
          list: parsedList,
        });
      }
    } catch (err) {
      console.error("Error loading FAQs:", err);
    } finally {
      setLoading(false);
    }
  }

  loadFaqs();
}, [i18n.language]);


  const handleToggle = (index) => {
    setOpenIndex((prev) => (prev === index ? null : index));
  };

  const sectionMarginBottom = isMobileS ? 0 : isSm ? 0 : isMd ? 650 : isLg ? 200 : 0;

  return (
    <Box
      sx={{
        position: "relative",
        mb: isMobile ? 0 : `${sectionMarginBottom}px`,
        backgroundColor: "white",
        py: isMobile ? 6 : 10,
      }}
    >
      {!isMobile && (
        <>
          <img
            src={faqsrightimage}
            style={{ position: "absolute", top: 90, right: 10, zIndex: 1 }}
            alt=""
          />
          <img
            src={faqsleftimage}
            style={{ position: "absolute", top: 400, left: 0, zIndex: 1 }}
            alt=""
          />
        </>
      )}

      <Box
        sx={{
          px: isMobile ? 2 : 13,
          display: "flex",
          flexDirection: "column",
        }}
      >
        {/* 🔹 Title from API */}
        <CustomText
          style={{
            ...textStyles.h3,
            color: "#072533",
            textAlign: "center",
            marginBottom: "1rem",
          }}
        >
          {loading ? <Skeleton height={40} width={300} /> : faqData.title}
        </CustomText>

        {/* 🔹 Description from API */}
        <CustomText
          style={{
            ...textStyles.body2,
            color: "#868282",
            maxWidth: "1105px",
            textAlign: "center",
            margin: "0 auto",
            fontSize: "20px",
          }}
        >
          {loading ? <Skeleton height={20} count={2} /> : faqData.description}
        </CustomText>

        {/* 🔹 FAQs List */}
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", md: "row" },
            alignItems: "stretch",
            gap: 3,
            mt: 5,
          }}
        >
          <Box
            sx={{
              flex: isMobile ? "unset" : 6.8,
              pr: 2,
            }}
          >
            {loading
              ? Array.from({ length: 5 }).map((_, i) => (
                  <Box key={i} sx={{ mb: 2 }}>
                    <Skeleton height={50} />
                  </Box>
                ))
              : faqData.list.map((faq, index) => (
                  <Box
                    key={faq.id || index}
                    sx={{
                      mb: 2,
                      border: "1px solid #E0E0E0",
                      borderRadius: "8px",
                    }}
                  >
                    <InfoCard
                      onClick={() => handleToggle(index)}
                      title={faq.name}
                      description={openIndex === index ? faq.value : ""}
                      icon={
                        <IconButton
                          onClick={(e) => {
                            e.stopPropagation();
                            handleToggle(index);
                          }}
                          size="small"
                        >
                          {openIndex === index ? (
                            <RemoveIcon sx={{ color: "#3D3D3D" }} />
                          ) : (
                            <AddIcon sx={{ color: "#3D3D3D" }} />
                          )}
                        </IconButton>
                      }
                    />
                  </Box>
                ))}
          </Box>

          {/* Right CTA Box */}
          <Box
            sx={{
              flex: 3.2,
              width: "100%",
              mx: "auto",
              minWidth: isMobile ? "auto" : "300px",
              zIndex: 2,
              display: "flex",
              flexDirection: "column",
            }}
          >
            <Box
              sx={{
                px: 2,
                py: 6,
                backgroundColor: "white",
                border: "1px solid #CFCFCF",
                borderRadius: "10px",
                textAlign: "center",
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
              }}
            >
              <Box>
                <Box sx={{ mb: 2 }}>
                  <img
                    src={faqsimage}
                    alt="chat icon"
                    style={{
                      width: "80px",
                      height: "80px",
                      objectFit: "contain",
                    }}
                  />
                </Box>
                <CustomText
                  customStyle={{
                    fontSize: "20px",
                    fontWeight: 700,
                    fontFamily: "Poppins, sans-serif",
                    color: "#100F0F",
                    mb: 2,
                  }}
                >
                   {t("need_help")}
                </CustomText>
                <CustomText
                  style={{
                    textAlign: "center",
                    fontSize: "14px",
                    marginTop: "15px",
                    fontWeight: 500,
                    fontFamily: "Poppins, sans-serif",
                    color: "#5E5C5C",
                    lineHeight: "180%",
                  }}
                >
                 {t("chat_whatsapp")}

                </CustomText>
              </Box>

              <Box mt={5}>
                <CustomButton
                  label={
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                      <Box
                        component="img"
                        src={whitechat}
                        alt="Chat"
                        sx={{ width: 30, height: 30, objectFit: "contain" }}
                      />
                      <Typography
                        component="span"
                        sx={{
                          fontSize: "inherit",
                          fontFamily: "'Poppins', sans-serif",
                          fontWeight: "inherit",
                          color: "inherit",
                        }}
                      >
                            {t("chat_with_us")}
                      </Typography>
                    </Box>
                  }
                  onClick={() => window.open("https://wa.me/593986124254", "_blank")}
                  buttonVariant="primary"
                  size="large"
                />
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default FAQsSection;



